import type { ReactNode } from "react";
import { Box, Typography, Chip } from "@mui/material";
import { dashboardCollectionChipColor } from "./dashboard-metrics";

export type DashboardHeaderProps = {
  title: ReactNode;
  collectionPercentage: number;
  /** Defaults to `Collection: {percentage}%`. */
  collectionChipLabel?: ReactNode;
};

export default function DashboardHeader({
  title,
  collectionPercentage,
  collectionChipLabel,
}: DashboardHeaderProps) {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
      <Chip
        label={collectionChipLabel ?? `Collection: ${collectionPercentage}%`}
        color={dashboardCollectionChipColor(collectionPercentage)}
        sx={{ fontWeight: 600 }}
      />
    </Box>
  );
}
